import qs from 'qs'
import { FC, ReactElement, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Route,
  BrowserRouter as Router,
  Switch, useLocation
} from 'react-router-dom'
import AuthGuard from './AuthGuard'
import Contact from './containers/contact'
import ExamResult from './containers/examResult'
import FAQandLoggedArea from './containers/faq'
import ForgotPasswordWithRecaptcha from './containers/forgotPassword'
import ForgotPasswordVerificationCode from './containers/forgotPassword/verificationCode'
import LabsList from './containers/labsList'
import NewLandingPage from './containers/landingPage/newLanding'
import Login from './containers/login'
import Logout from './containers/logout'
import Patients from './containers/patients'
import ProcessExam from './containers/processExam'
import RequestNewLab from './containers/processExam/requestNewLab'
import Profile from './containers/profile'
import Register from './containers/register'
import RegisterVerificationCode from './containers/register/verificationCode'
import Subscription from './containers/subscription'
import { RoutesEnum } from './utils/routesEnum'

const MultiLanguageRoute: FC = (): null => {
  const location = useLocation()

  const { lang }: { lang?: string } = qs.parse(location.search, { ignoreQueryPrefix: true })

  const { i18n } = useTranslation('translation')

  useLayoutEffect(() => {
    if (lang === 'pt') i18n.changeLanguage('pt')
    else if (lang === 'en') i18n.changeLanguage('en')
  }, [lang, i18n])

  return null
}

const Routes = (): ReactElement => {
  return (
    <Router>
      <>
        <Route path='/' component={MultiLanguageRoute} />
        <Switch>
          <Route exact path={RoutesEnum.HOME}>
            <NewLandingPage />
          </Route>
          <Route exact path={RoutesEnum.REGISTER}>
            <Register />
          </Route>
          <Route exact path={RoutesEnum.REGISTER_WITH_ACCESS_CODE}>
            <Register withAccessCode />
          </Route>
          <Route exact path={RoutesEnum.LOGIN}>
            <Login />
          </Route>
          <Route exact path={RoutesEnum.LOGOUT}>
            <Logout />
          </Route>
          <Route exact path={RoutesEnum.REGISTER_VERIFICATION_CODE}>
            <RegisterVerificationCode />
          </Route>
          <Route exact path={RoutesEnum.FORGOT_PASSWORD}>
            <ForgotPasswordWithRecaptcha />
          </Route>
          <Route exact path={RoutesEnum.FORGOT_PASSWORD_VERIFICATION_CODE}>
            <ForgotPasswordVerificationCode />
          </Route>
          <Route exact path={RoutesEnum.LABS_LIST}>
            <LabsList />
          </Route>
          <Route path='/'>
            <AuthGuard>
              <Switch>
                <Route exact path={RoutesEnum.PROCESS_EXAMS}>
                  <ProcessExam type='upload' />
                </Route>
                <Route exact path={RoutesEnum.PROCESS_EXAMS_REQUEST_LAB}>
                  <RequestNewLab />
                </Route>
                <Route exact path={RoutesEnum.PROCESS_EXAMS_TYPE}>
                  <ProcessExam type='type' />
                </Route>
                <Route exact path={RoutesEnum.PROCESSED_EXAMS}>
                  <ExamResult />
                </Route>
                <Route exact path={RoutesEnum.PROFILE}>
                  <Profile />
                </Route>
                <Route exact path={RoutesEnum.SUBSCRIPTION}>
                  <Subscription type='plans' />
                </Route>
                <Route exact path={RoutesEnum.SUBSCRIPTION_STATEMENT}>
                  <Subscription type='statement' />
                </Route>
                <Route exact path={RoutesEnum.FAQ}>
                  <FAQandLoggedArea />
                </Route>
                <Route exact path={RoutesEnum.CONTACT}>
                  <Contact />
                </Route>
                <Route exact path={RoutesEnum.PATIENTS}>
                  <Patients type='list' />
                </Route>
                <Route exact path={RoutesEnum.PATIENTS_VIEW}>
                  <Patients type='view' />
                </Route>
                <Route exact path={RoutesEnum.PATIENTS_CREATE}>
                  <Patients type='create' />
                </Route>
                <Route exact path={RoutesEnum.PATIENTS_EDIT}>
                  <Patients type='edit' />
                </Route>
              </Switch>
            </AuthGuard>
          </Route>
        </Switch>
      </>
    </Router>
  )
}

export default Routes
